var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounDelete1123191(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.628,
    height: 16.725,
    viewBox: "0 0 12.628 16.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-1123191",
    transform: "translate(-156.435 -21.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5074",
    "data-name": "Path 5074",
    d: "M161.464,35.144h.008a.439.439,0,0,0,.431-.447l-.176-9.448a.439.439,0,0,0-.439-.431h-.008a.439.439,0,0,0-.431.447l.176,9.448A.439.439,0,0,0,161.464,35.144Zm2.569,0a.439.439,0,0,0,.439-.431l.176-9.448a.439.439,0,0,0-.431-.447h-.008a.439.439,0,0,0-.439.431l-.176,9.448a.439.439,0,0,0,.431.447Zm3.454-10.326a.44.44,0,0,0-.453.425l-.352,10.93a.54.54,0,0,1-.539.54h-6.789a.544.544,0,0,1-.54-.554l-.351-10.916a.439.439,0,0,0-.878.028l.351,10.9a1.42,1.42,0,0,0,1.418,1.418h6.789a1.416,1.416,0,0,0,1.417-1.4l.351-10.916a.439.439,0,0,0-.425-.453Zm.886-1.757h-2.758l-.279-1.346a.439.439,0,0,0-.43-.35h-4.314a.439.439,0,0,0-.43.35l-.279,1.346h-2.76a.439.439,0,0,0,0,.878h11.249a.439.439,0,1,0,0-.878Zm-7.593,0,.169-.818h3.6l.169.818Z",
    fill: "#4EB6EE",
    stroke: "#fe9b14",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounDelete1123191);
export default __webpack_public_path__ + "static/media/noun-delete-1123191.56459cc3394bc7cd46fe5156343f055b.svg";
export { ForwardRef as ReactComponent };